import { Validator } from '@vista-digital/validator';
import { inputFieldDisplayTextValidator } from '../../../../subcomponents/form/field/input/types/display-text';
import { InvalidFieldNameError } from '../../../../types/invalid-field-name-error';
import { defaultTicketRedemptionCodeFormCodeFieldDisplayText, defaultTicketRedemptionCodeFormPinFieldDisplayText, defaultTicketRedemptionCodeFormTypeFieldDisplayText } from './display-text';
import { TicketRedemptionCodeFormFieldName } from './name';
export const ticketRedemptionCodeFormFieldPropsValidator = Validator.object({
    name: Validator.oneOf(Object.values(TicketRedemptionCodeFormFieldName)),
    displayText: inputFieldDisplayTextValidator
});
const defaultCodeFieldProps = {
    name: TicketRedemptionCodeFormFieldName.Code,
    displayText: defaultTicketRedemptionCodeFormCodeFieldDisplayText
};
const defaultPinFieldProps = {
    name: TicketRedemptionCodeFormFieldName.Pin,
    displayText: defaultTicketRedemptionCodeFormPinFieldDisplayText
};
const defaultTypeFieldProps = {
    name: TicketRedemptionCodeFormFieldName.Type,
    displayText: defaultTicketRedemptionCodeFormTypeFieldDisplayText
};
export const defaultTicketRedemptionCodeFormFieldPropsProvider = props => {
    switch (props.name) {
        case TicketRedemptionCodeFormFieldName.Code:
            return defaultCodeFieldProps;
        case TicketRedemptionCodeFormFieldName.Pin:
            return defaultPinFieldProps;
        case TicketRedemptionCodeFormFieldName.Type:
            return defaultTypeFieldProps;
        default:
            throw new InvalidFieldNameError('TicketRedemptionCodeFormFieldProps', props.name);
    }
};
